import { appUrl, safeNextPath } from '../apps';

/** Hub sign-in URL that returns the user to `next` (a same-origin path, possibly in another app). */
export function signInUrl(next?: string | null): string {
  const target = safeNextPath(next, '/');
  return target === '/'
    ? appUrl('hub', '/sign-in')
    : `${appUrl('hub', '/sign-in')}?next=${encodeURIComponent(target)}`;
}

/** Absolute callback URL for email links and OAuth (the only redirect URL allow-listed in Supabase). */
export function authCallbackUrl(origin: string, next?: string | null): string {
  const target = safeNextPath(next, '/');
  const base = `${origin}${appUrl('hub', '/auth/callback')}`;
  return target === '/' ? base : `${base}?next=${encodeURIComponent(target)}`;
}

/** The current location as a path suitable for `next` (path + query + hash). */
export function currentPath(location: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
  return `${location.pathname}${location.search}${location.hash}`;
}
